import { render } from "./QuestionBankManagement.vue?vue&type=template&id=6e4ba5f8&scoped=true"
import script from "./QuestionBankManagement.vue?vue&type=script&lang=js"
export * from "./QuestionBankManagement.vue?vue&type=script&lang=js"

import "./QuestionBankManagement.vue?vue&type=style&index=0&id=6e4ba5f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4ba5f8"]])

export default __exports__